<script setup lang="ts">
import type { Product } from '@/types/Product';
import type { CardSearchParams } from '@/types/SearchBar';
import ProductTeaser from './ProductTeaser.vue';

interface Props {
  products: Product[];
  columns?: 1 | 2 | 3 | 4;
  searchParams?: CardSearchParams;
}

withDefaults(defineProps<Props>(), {
  columns: 3,
  searchParams: undefined,
});
</script>

<template>
  <div
    :class="[
      'grid gap-8 md:gap-10',
      {
        'grid-cols-1': columns === 1,
        'grid-cols-1 md:grid-cols-2': columns === 2,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3': columns === 3,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': columns === 4,
      },
    ]"
  >
    <ProductTeaser
      v-for="product in products"
      :key="product.id"
      :product="product"
      :search-params="searchParams"
    />
  </div>
</template>
